module.exports = ".login-background {\n  background: url(\"/assets/images/login-bg.jpg\") no-repeat center center fixed;\n  background-size: cover;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.8);\n  -webkit-filter: brightness(0.4);\n          filter: brightness(0.4); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/public-background/public-background.component.scss
// module id = ./src/app/shared-components/public-background/public-background.component.scss
// module chunks = main